import { createContext, useContext } from 'react';

interface AuthSuccessContextValue {
    onAuthSuccess?: () => void;
}

export const AuthSuccessContext = createContext<AuthSuccessContextValue>({});

export const useAuthSuccess = () => useContext(AuthSuccessContext);
